export default __webpack_public_path__ + "static/media/963.83335daa.png";